import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import { AppSelectors } from 'app/shared/selectors';

import {
    Flex,
    FormField,
    Image,
    Label,
    List,
    Select,
    Spacer,
    Text,
} from '@zillow/constellation';

import { Center } from '@zillow/zrs-comet';

import ModalFooter from 'app/shared/components/Modal/ModalFooter';
import ForSaleSign from 'app/shared/images/addPropertyPage/ForSaleSign.svg';

import accessUtils from 'app/shared/utils/accessUtils';

import {
    StyledMDActionsContainer,
    StyledMDContainer,
    StyledMDContent,
    StyledMDContentContainer,
} from 'app/shared/containers/ModalContainer/StyledComponents';

const propTypes = {
    contracts: PropTypes.arrayOf(PropTypes.shape({
        customerId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        unitOfMeasure: PropTypes.string.isRequired,
    })).isRequired,
    mustSetActiveContract: PropTypes.bool.isRequired,
    hasDupes: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const PreActivationModal = ({
    contracts,
    mustSetActiveContract,
    hasDupes,
    onCancel,
    onSubmit,
}) => {
    const [customerId, setCustomerId] = React.useState(mustSetActiveContract ? contracts[0].customerId : null);
    const cookieEnabledServices = useSelector(state => AppSelectors.makeCookieEnabledServices(state));
    const appConfig = useSelector(state => AppSelectors.makeAppConfig(state));
    const handleOnSubmit = () => onSubmit(customerId);

    const canFeedConnectSwitchSource = accessUtils.canFeedConnectSwitchSource({ appConfig, cookieEnabledServices });

    const infoList = [
        'Renters will now see the Zillow Rental Manager version of the listing on Zillow, Trulia & HotPads',
    ];

    if (contracts.length === 1 && contracts[0].unitOfMeasure) {
        const rate = contracts[0].unitOfMeasure === 'day' ? 'daily' : 'monthly';
        infoList.push(`This listing will be billed at your ${rate} rate and included in your monthly invoice.`);
    } else {
        infoList.push('This listing will be included in your monthly invoice.');
    }

    if (hasDupes && canFeedConnectSwitchSource) {
        infoList.push('You can switch to another listing source at any time.');
    }

    return (
        <StyledMDContainer>
            <StyledMDContentContainer>
                <StyledMDContent>
                    <Spacer marginBottom="xs">
                        <Flex display="flex" flexDirection="column" alignItems="center">
                            <Spacer marginY="xs">
                                <Image src={ForSaleSign} alt="For sale sign" />
                            </Spacer>
                            <Spacer paddingBottom="sm">
                                <Center>
                                    <Text fontType="h6">
                                        Things you need to know before publishing:
                                    </Text>
                                </Center>
                            </Spacer>
                            <List className="PreActivationModal-List">
                                {infoList.map((item, index) => (
                                    <List.Item key={index}>{item}</List.Item>
                                ))}
                            </List>
                        </Flex>
                    </Spacer>
                    {mustSetActiveContract && contracts.length > 1 && (
                        <FormField paddingY={2}>
                            <Label>Active Contracts</Label>
                            <Select
                                aria-label="Active contracts"
                                value={customerId || 'Please select'}
                                onChange={e => setCustomerId(e.target.value)}
                            >
                                {contracts.map(contract => (
                                    <option key="contract.customerId" value={contract.customerId}>
                                        {contract.name}
                                    </option>
                                ))}
                            </Select>
                        </FormField>
                    )}
                </StyledMDContent>
                <StyledMDActionsContainer>
                    <ModalFooter
                        cancelText="Cancel"
                        submitText="Yes, publish"
                        onSubmit={handleOnSubmit}
                        onCancel={onCancel}
                    />
                </StyledMDActionsContainer>
            </StyledMDContentContainer>
        </StyledMDContainer>
    );
};

PreActivationModal.propTypes = propTypes;

export { PreActivationModal };
export default PreActivationModal;
